<template>
  <div>
    <v-card outlined :loading="loading">
      <v-container fluid style="padding-top: 1px; padding-bottom: 1px">
        <v-row dense no-gutters>
          <v-col md="4" v-for="(file, index) in files" :key="index">
            <v-list-item style="padding: 1px">
              <v-list-item-action>
                <menu-item
                  :items="menuItems(file._id)"
                  :id="file._id"
                  @menuAction="menuAction"
                />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ file.fileName }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions
        v-if="!soloLectura"
        style="padding-top: 1px; padding-bottom: 10px"
      >
        <subir-documento
          :tipo="tipo"
          :id="id"
          :nombre="files.length == 0 ? numero : null"
          @documentoCargado="documentoCargado"
          @nuevoLog="nuevo => $emit('nuevoLog', nuevo)"
        />
      </v-card-actions>
    </v-card>

    <!-- DIALOG PARA ELIMINAR DOCUMENTO -->
    <v-dialog v-model="eliminarDialog.mostrar" width="400px" persistent>
      <v-card :loading="loading">
        <v-card-title class="headline">Eliminar documento</v-card-title>
        <v-card-text
          >¿Está seguro en eliminar el documento "{{
            eliminarDialog.nombre
          }}"?</v-card-text
        >
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="blue-grey darken-1"
            small
            outlined
            text
            @click="eliminarDialog.mostrar = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue-grey darken-1"
            small
            dark
            @click="eliminarDocumento()"
            >Eliminar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

import SubirDocumento from "./subirDocumento";
import MenuItem from "../menus/MenuItem";

export default {
  props: ["files", "id", "tipo", "soloLectura", "numero"],
  components: {
    SubirDocumento,
    MenuItem,
  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken", "userId"]),
  },
  data: () => ({
    loading: false,
    eliminarDialog: {
      mostrar: false,
      idDocumento: null,
      nombre: null,
    },
  }),
  methods: {
    documentoCargado(nuevoDocumento) {
      // console.log(nuevoDocumento);
      this.$emit("documentoCargado", nuevoDocumento);
    },
    menuItems(id) {
      let menuItems = [];
      let documento = this.files.find((x) => x._id == id);
      if (documento.type == "application/pdf")
        menuItems.push({
          text: "Previsualizar documento",
          action: "previsualizarDocumento",
        });
      menuItems.push({
        text: "Descargar documento",
        action: "descargarDocumento",
      });
      if (!this.soloLectura)
        menuItems.push({
          text: "Eliminar documento",
          action: "eliminarDocumento",
        });
      return menuItems;
    },
    menuAction(action, id) {
      let documento = null;
      switch (action) {
        case "eliminarDocumento":
          documento = this.files.find((x) => x._id == id);
          this.eliminarDialog.idDocumento = id;
          this.eliminarDialog.nombre = documento.fileName;
          this.eliminarDialog.mostrar = true;
          break;
        case "descargarDocumento":
          documento = this.files.find((x) => x._id == id);
          this.descargarDocumento(id, documento.fileName);
          break;
        case "previsualizarDocumento":
          documento = this.files.find((x) => x._id == id);
          this.previsualizarDocumento(id, documento.type);
          break;
      }
      // console.log(action, id);
    },
    eliminarDocumento() {
      this.loading = true;
      // console.log(this.eliminarDialog);
      axios
        .delete(
          this.httpURL +
            "/oficios/documento/" +
            this.tipo +
            "/" +
            this.id +
            "/" +
            this.eliminarDialog.idDocumento,
          { headers: { token: this.sessionToken } }
        )
        .then((res) => {

          if (res.data.ok) {
            this.$notify({
              group: "gral_notif",
              type: "success",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje,
            });
            this.$emit("documentoEliminado",this.eliminarDialog.idDocumento);
            this.$emit("nuevoLog")

            this.eliminarDialog.idDocumento = null;
            this.eliminarDialog.nombre = null;
            this.eliminarDialog.mostrar = false;
          } else {
            this.$notify({
              group: "gral_notif",
              type: "error",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje,
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          // console.log('Error: '+error);
          this.loading = false;
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: "Ocurrió un error al hacer la petición",
          });
        });
    },
    descargarDocumento(id, nombre) {
      this.loading = true;
      axios({
        url:
          this.httpURL +
          "/oficios/documento/" +
          this.tipo +
          "/" +
          this.id +
          "/" +
          id,
        method: "GET",
        responseType: "blob", // important
        data: {},
        headers: { token: this.sessionToken },
      })
        .then((res) => {
          //console.log(doc);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nombre);
          link.click();
          this.loading = false;
        })
        .catch((error) => {
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: "No se pudo realizar la operación.",
          });
          this.loading = false;
        });
    },
    previsualizarDocumento(id, tipo) {
      this.loading = true;
      axios({
        url: this.httpURL+"/oficios/documento/"+this.tipo+"/"+this.id+"/" +id,
        method: "GET",
        responseType: "blob", // important
        data: {},
        headers: { token: this.sessionToken },
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data], { type: tipo }));
          window.open(url);
          this.loading = false;
        })
        .catch((error) => {
          this.$notify({group: "gral_notif",type: "error", duration: 1500,speed: 500,text: "No se pudo realizar la operación."});
          this.loading = false;
        });
    },
  },
};
</script>